import JobGridNoSidebarContainer from "../../../components/job/grid/JobGridNoSidebar";

const JobGridNoSidebar = () => {
  return <JobGridNoSidebarContainer />;
};

export default JobGridNoSidebar;
